import {
  Box,
  Tab,
  TabList,
  TabPanel,
  TabPanels,
  Tabs,
  Text,
} from '@chakra-ui/react';
import React, { useEffect, useLayoutEffect, useState } from 'react';
import Applications_page from '../Application_View/Applications_page';
import SentInvite_Page from '../SentView/SentInvite_Page';
import * as api from '../../../services/api';
const DetailsPage_Component = ({ postId }) => {
  const [applicationData, setApplicationData] = useState({});
  const [invitesData, setInvitesData] = useState({});

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    window.scrollTo(0, 0);
  
    const getAllApplicationsForJob = async () => {
      if (postId) {
        const applications = await api.getAllApplicationsForJob(postId);
        setApplicationData(applications.data.data);
      }
    };
    const getAllInvitesForJobPost = async () => {
      if (postId) {
        const invites = await api.getAllInvitesForJobPost(postId);
        setInvitesData(invites.data.data);
      }
    };
    getAllApplicationsForJob();
    getAllInvitesForJobPost();
  }, [postId]);
  return (
    <div>
      <Box
      // display={["flex", "none", "flex", "none", "flex",'none']}
     
      >
        <Tabs colorScheme='purple.500'>
          <TabList pt={5}>
            <Tab _active='none' textDecoration='none' ml={5}>
              <Text
                fontSize={16}
                fontWeight={500}
                fontFamily={'Roboto'}
                letterSpacing={'0.04em'}
                color='#0B0019'
              >
                Applications ({applicationData?.data?.length})
              </Text>
            </Tab>
            <Tab _active='none' textDecoration='none'>
              <Text
                fontSize={16}
                fontWeight={500}
                fontFamily={'Roboto'}
                letterSpacing={'0.04em'}
                color='#0B0019'
              >
                Sent Invites
              </Text>
            </Tab>
          </TabList>
          <TabPanels>
            <TabPanel
              css={{
                '@media  (min-width: 1542px) and  (max-width: 1980px)': {
                  width: 1300,
                },
                '@media (min-width: 1442px) and (max-width: 1540px)': {
                  width: 948,
                },
                '@media (min-width: 1240px) and (max-width: 1440px)': {
                  width: 680,
                },
              }}
            >
              <Applications_page
                applicationData={applicationData.data}
                // title={}
              />
            </TabPanel>
            <TabPanel
              css={{
                '@media  (min-width: 1542px) and  (max-width: 1980px)': {
                  width: 1300,
                },
                '@media (min-width: 1442px) and (max-width: 1540px)': {
                  width: 948,
                },
                '@media (min-width: 1240px) and (max-width: 1440px)': {
                  width: 680,
                },
              }}
            >
              <SentInvite_Page data={invitesData.data} />
            </TabPanel>
          </TabPanels>
        </Tabs>
      </Box>
    </div>
  );
};
export default DetailsPage_Component;
